export default __webpack_public_path__ + "static/icecube-940689963d7640149115d100e65258d9.png";